// document.addEventListener('DOMContentLoaded', () => {
//   console.log('DOMContentLoaded event triggered');
//   const cart = window.theme.cart;
//   if (cart && cart.cart_level_discount_applications) {
//     const discountApplications = cart.cart_level_discount_applications;
//     if (discountApplications.length > 0) {
//       console.log('Discounts applied:', discountApplications);
//       showDiscountNotification(discountApplications);
//     } else {
//       console.log('No discounts applied');
//     }
//   } else {
//     console.log('Cart or cart_level_discount_applications not available');
//   }
// });

// function showDiscountNotification(discountApplications) {
//   console.log('showDiscountNotification function called');
//   const discountDiv = document.getElementById('discount-message');
//   console.log('Discount div:', discountDiv);
//   if (!discountDiv) {
//     console.log('Discount div is not found, creating a new one');
//     discountDiv = document.createElement('div');
//     discountDiv.id = 'discount-message';
//     const discountText = document.createElement('span');
//     discountText.textContent = 'Discount Applied!';
//     discountDiv.appendChild(discountText);
//     document.body.appendChild(discountDiv);
//     console.log('Discount div created and appended:', discountDiv);
//   }
//   console.log('Adding show class to discount div');
//   discountDiv.classList.add('show');
//   console.log('Discount div after adding show class:', discountDiv);
//   setTimeout(() => {
//     console.log('Removing show class from discount div');
//     discountDiv.classList.remove('show');
//   }, 3000);
// }


// if (window.theme.cartItemCount > 0) {
//   Shopify.getCart(function(cart) {
//     if (cart.total_discount > 0) {
//       console.log('A discount has been applied to the cart');
//       // You can also display a notification to the user here
//     } else {
//       console.log('No discount has been applied to the cart');
//     }
//   });
// } else {
//   console.log('The cart is empty');
// }






function getDiscountCode() {
  var cookies = document.cookie.split("; ");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].split("=");
    if (cookie[0] == "discount_code") {
      return cookie[1];
    }
  }
  return null;
}

function displayDiscountNotification() {
  let discountDiv = document.getElementById('discount-message');
  if (!discountDiv) {
    discountDiv = document.createElement('div');
    discountDiv.id = 'discount-message';
    const discountText = document.createElement('span');
    discountText.textContent = 'Discount Applied!';
    discountDiv.appendChild(discountText);
    document.body.appendChild(discountDiv);
  }
  discountDiv.classList.add('show');
  setTimeout(() => {
    discountDiv.classList.remove('show');
  }, 10000);
}

var discountCode = getDiscountCode();
if (discountCode) {
  //console.log('Discount code found:', discountCode);
  var alreadyDisplayed = localStorage.getItem('discountNotificationDisplayed');
  if (!alreadyDisplayed) {
    displayDiscountNotification();
    localStorage.setItem('discountNotificationDisplayed', 'true');
  } else {
    //console.log('Discount notification already displayed.');
  }
} else {
  //console.log('No discount code found.');
}
